import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getUsers } from "../../redux/actions/actionUser";
import UserCard from "./userCard";

export default function Users(){
    const users = useSelector((state)=> state.users.allUsers)
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getUsers())
    }, [dispatch])

    console.log(users)

    return (
        <div className="container m-16">
        <div>
                <p className="text-xl pb-8 underline">Usuarios - Informes</p>
            </div>
            <div className="container">
                <div className="grid grid-cols-4 gap-2 m-0.5 bg-slate-300">
                    {/* <div>Id</div> */}
                    <div>Apellido</div>
                    <div>Nombre</div>
                    <div>Usuario Id</div>
                    <div>Tipo</div>
                </div>
                {users.map(e=> (
                    <UserCard
                    key={e._id}
                    id={e._id}
                    name={e.name}
                    lastName={e.lastName}
                    userId={e.userId}
                    type={e.type}
                    />
                ))}
            </div>
        </div>
    )
}